export default __webpack_public_path__ + "src/favicon.ico";